// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RemoveFromJobModal-wrapper {
  width: 500px;
}
.RemoveFromJobModal-wrapper h3 {
  font-size: 24px;
  font-weight: 600;
  color: var(--color_neutral_900);
}
.RemoveFromJobModal-wrapper p {
  font-size: 14px;
  color: var(--color_neutral_800);
}
.RemoveFromJobModal-wrapper [class^=dist_Checkbox-wrapper] {
  font-size: 14px;
  color: var(--color_neutral_800);
  margin: 16px 0px 0px;
}
.RemoveFromJobModal-wrapper .buttonsSection {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  column-gap: 16px;
  margin-top: 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectedItemsBar/components/RemoveFromJobModal/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AACJ;AAEE;EACE,eAAA;EACA,+BAAA;AAAJ;AAIE;EACE,eAAA;EACA,+BAAA;EACA,oBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAHJ","sourcesContent":[".RemoveFromJobModal-wrapper {\n  width: 500px;\n\n  h3 {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--color_neutral_900);\n  }\n\n  p {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n  }\n\n\n  [class^=\"dist_Checkbox-wrapper\"] {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n    margin: 16px 0px 0px;\n  }\n\n  .buttonsSection {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: flex-end;\n    column-gap: 16px;\n    margin-top: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
